import React from "react";
import { Parallax } from "react-parallax";
import {
  ParallaxContainer,
  ParallaxText,
} from "../../style/parallax/parallaxStyle";

const ParallaxComponent = () => {
  return (
    <Parallax
      bgImage="https://res.cloudinary.com/dt5eiyxyc/image/upload/v1778993305/0_ifyCJW0h6tRKQwxp_w6zg5u.png"
      strength={-200}
      style={{ width: "100%" }}
    >
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0, 0, 0, 0.6)",
      }} />
      <ParallaxContainer>
        <ParallaxText>
          "Success is achieved with a series of risks, compromisations and
          sacrifications"
        </ParallaxText>
      </ParallaxContainer>
    </Parallax>
  );
};

export default ParallaxComponent;